import { dexApi } from './apiBase.js'
import { apiFetch } from './apiClient.js'

/**
 * All DEX (LTDashboard) API calls go through this module.
 *
 * Usage:
 *   dexFetch('/api/users/me')                     → GET same-origin if on dex, cross-origin from cex.
 *   dexFetch('/api/knowledge/upload', { method, body: formData })
 *       Body is FormData → Content-Type omitted so browser adds multipart boundary.
 *   dexFetch('https://…/absolute')               → passed through untouched.
 *
 * Always sends credentials (cookie on `.lotosterminal.pro` carries session).
 */
function isBodyLessType(body) {
  if (body == null) return false
  if (typeof body === 'string') return false
  if (typeof FormData !== 'undefined' && body instanceof FormData) return true
  if (typeof Blob !== 'undefined' && body instanceof Blob) return true
  if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) return true
  if (typeof ArrayBuffer !== 'undefined' && body instanceof ArrayBuffer) return true
  if (ArrayBuffer.isView && ArrayBuffer.isView(body)) return true
  return false
}

export async function dexFetch(path, init = {}) {
  const url = /^https?:\/\//.test(path) ? path : dexApi(path)
  const headers = { ...(init.headers || {}) }
  const bodyIsStream = isBodyLessType(init.body)
  const hasContentType = Object.keys(headers).some((k) => k.toLowerCase() === 'content-type')
  if (!bodyIsStream && !hasContentType && init.body != null) {
    headers['Content-Type'] = 'application/json'
  }
  if (!bodyIsStream && !hasContentType && init.body == null && (init.method || 'GET').toUpperCase() !== 'GET') {
    headers['Content-Type'] = 'application/json'
  }
  const res = await apiFetch(url, {
    credentials: 'include',
    cache: init.cache ?? 'no-store',
    ...init,
    headers,
  })
  return res
}

export async function dexJson(path, init) {
  const res = await dexFetch(path, init)
  if (!res.ok) {
    const text = await res.text().catch(() => '')
    throw new Error(`dex ${path} ${res.status}: ${text}`)
  }
  return res.json()
}
